import { Dexie, Table } from 'dexie';
import { Notification } from '@dynamik/common/clients/notification-clients';

export class NotificationDB extends Dexie {
  notifications: Table<Notification, string>;
  processedNatsSequences: Table<{ companyIdentityId: number, sequence: number }, number>;

  constructor() {
    super('Notifications');
    this.version(1).stores({
      notifications: 'id, [companyIdentityId+date]',
      processedNatsSequences: 'sequence,[companyIdentityId+sequence]'
    });
    this.notifications.mapToClass(Notification);
  }
}
